<template>
	<div>
		<div class="bg">
<!--			<template  v-if="isNames">-->
<!--				<houses v-if="modules" :houseList="houseList"></houses>-->
<!--			</template>-->
			<div class="flexs-eve">
				<div class="img-cen" @click="goInfo('/onlineDeposit/otherHouseDeposit','为他人代交')">
					<img src="./static/deposit1.png" style="width:60px;height: 60px;">
					<div>为他人代交</div>
				</div>
				<div class="img-cen" @click="goInfo('/onlineDeposit/DepAgreeList','我的签署')">
					<img src="./static/deposit2.png" class="images">
					<div>我的签署</div>
				</div>
				<div class="img-cen" @click="goInfo('/onlineDeposit/billSignObtain/billSignObtain','订单查询')">
					<img src="./static/deposit3.png" class="images">
					<div>订单查询</div>
				</div>
			</div>
    </div>
      <van-card v-for="(item, index) in houseList" :key="index">
        <div slot="title" >
          <van-row>
            <van-col span="18">
              <div class="titleContent"  style="padding:10px 10px 10px 10px" >{{item.address}}</div>
            </van-col>
            <van-col span="6">
              <div style="float:right;text-align: right;padding: 10% 0 0 0 " >
                <!--          <div class="titleContent" style="float:right" >未交</div>-->
                <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.depositSign === 'X'" plain>未 交</van-button>
                <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.depositSign === 'N'" plain>未 足 额</van-button>
                <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.depositSign === 'Y'" plain>足 额</van-button>
                <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.depositSign === 'F'" plain>免 交</van-button>
              </div>
            </van-col>
          </van-row>


        </div>
        <div slot="desc" style="top:12px">
          <van-cell-group>
<!--            <van-cell title="房屋id" :value="item.houseNo" />-->
            <van-cell title="房屋面积" :value="item.constructAreaFormat+'㎡'" />
            <van-cell title="交存模式" :value="item.depositName" />
            <van-cell title="应交金额" :value="item.dueAmountFormat+'(元)'" />
            <van-cell v-if="item.depositSign!=='X'&&item.transmitState=='00'" class="depositMessage" :value="item.message" style="color: #F59A23">
              {{item.depositSign|depFilter}}
            </van-cell>
            <van-cell v-if="item.depositSign!=='X'&&item.transmitState=='01'" class="depositMessage" :value="'房屋已发起单位交存申请，暂时无法通过本渠道进行交存'" style="color: #F59A23"/>
            <van-row type="flex" justify="center" v-if="item.depositSign === 'X'">
              <van-col span="22" >
                <van-button type="primary" size="normal" class="btn" @click="signCommit(item)">支 付</van-button>
              </van-col>
            </van-row>
            <van-cell v-if="item.depositSign==='Z'" class="depositMessage" :value="item.message" style="color: #F59A23">
              约定书已冻结，请等待主管单位签署撤销。
            </van-cell>

          </van-cell-group>
        </div>
        <div class="footer" slot="footer">
        </div>
      </van-card>
  </div>
</template>

<script>

import {depositApply, myHtHouseList,checkRegion} from "@/api/maintainFund/maintainFund";
  export default {
    name: 'OnlineDeposit',//页面name
		components:{
		},
    filters:{
      depFilter(status){
        if(status==='N'){
          return '房屋为未足额状态，暂时无法通过本渠道进行交存。'
        }
        if(status==='Y'){
          return '房屋为足额状态，无需进行交存。'
        }
        if(status==='F'){
          return '房屋为免交状态，无需进行交存。'
        }
      }
    },
		data() {
			return {
				modules:false,
				replacesRef:false,
				showOnline:false,
				showNotice:false,
				showContract:false,
				// showUrge:false,
				showRecord:false,
				isNames:this.$store.getters.isCertificationSuccess,
				query: {
					pageNum: 1,
					pageSize: 15,
				},
				houseList:[],
				infos:{}
			}
		},

    mounted() {
      this.showLoading();
      myHtHouseList().then(res => {
        console.log(res)
        this.houseList = res.data.houseInfoList;
        this.$toast.clear();
      });
      this.$toast.clear();
    },

		onShow() {

		},
		methods: {
    showLoading() {
        this.$toast.loading({
          // 持续展示 toast
          duration: 0,
          mask: true,
          message: '加载中...'
        });
      },
      goInfo(path,titleName) {
        this.$router.push({path: path, query: {label: titleName}})
      },
      signCommit(item){
        console.log(item)
        checkRegion(item.houseNo).then(res =>{
          console.log(res.data)
          if (res.data === 'Y'){
            let owner = {
              divisionCode: item.divisionCode,
              regionNo: item.regionNo,
              bldNo: item.bldNo,
              cellNo: item.cellNo,
              houseNo: item.houseNo,
              isowner: 'Y',
            };
            depositApply(owner).then(res => {
              if (res.data.retCode === '0000') {
                this.$dialog.alert({
                  message: res.data.retDesc
                }).then(() => {
                  this.$router.push({
                    path: '/maintainFund/depositInfo',
                    query: {
                      label: '交存申请',
                      payChannels: res.data.payChannels,
                      houseDepMobiles: res.data.houseDepMobiles
                    }
                  })
                });
              } else if (res.data.retCode === '0001') {
                //代交
                this.$dialog.alert({
                  message: res.data.retDesc,
                  showCancelButton: true
                }).then(() => {
                  this.$router.push({
                    path: '/maintainFund/ownerConfirm',
                    query: {
                      houseNo: res.data.houseNo,
                      subAccount: res.data.subAccount
                    }
                  })
                }).catch(() => {
                  console.info("用户取消了交存...");
                });
              }
            })

            // eSignCheck(owner).then(res => {
            //   if (res.data.retCode === '00000'){
            //     sessionStorage.setItem('payChannels',JSON.stringify({payChannels:res.data.payChannels}));
            //     sessionStorage.setItem('houseDepMobiles',JSON.stringify({houseDepMobiles:res.data.houseDepMobiles}));
            //
            //     this.$router.push({path: '/onlineDeposit/depositMessage',
            //       query: {
            //         label: '交存申请',
            //         payChannels: res.data.payChannels,
            //         houseDepMobiles: res.data.houseDepMobiles}})
            //   }else {
            //     if (res.data.retCode === '0000') {  // 自交或者代交
            //       this.$dialog.alert({
            //         message: res.data.retDesc
            //       }).then(() => {
            //         this.$router.push({
            //           path: '/onlineDeposit/signUserMessage',
            //           query: {label: '签署人信息', owner: res.data.eSignRespose}
            //         })
            //       });
            //     } else if (res.data.retCode === '1001') {
            //       this.$router.push({
            //         path: '/onlineDeposit/signChild/waitSign',
            //         query: {label: '等待交存约定书签署', depositApply: res.data}
            //       })
            //     } else if (res.data.retCode === '1002') {
            //       // 他人签署中
            //       this.$dialog.alert({message: res.data.retDesc});
            //     } else if (res.data.retCode === '1000') {
            //       sessionStorage.setItem('payChannels', JSON.stringify({payChannels: res.data.payChannels}));
            //       sessionStorage.setItem('houseDepMobiles', JSON.stringify({houseDepMobiles: res.data.houseDepMobiles}));
            //
            //       this.$router.push({
            //         path: '/onlineDeposit/depositMessage',
            //         query: {
            //           label: '交存申请',
            //           payChannels: res.data.payChannels,
            //           houseDepMobiles: res.data.houseDepMobiles
            //         }
            //       })
            //     }
            //   }
            // })
          } else {
            this.$dialog.alert({
              message: "当前小区暂未开放在线交存功能"
            })
          }
        })
      }
		}
	}
</script>

<style  lang='scss' scoped>
	.flexs-eve{
		display: flex;justify-content: space-evenly;
		padding-top: 20px;
	}
	.flexs{
		display: flex;
	}
	.houses{
		justify-content: space-between;
		padding: 0 15px;
	}
	.padding-r5{
		padding-right: 5px;
	}

	.shadow{
		margin: 0 10px;
		box-shadow: 0px 0px 20px #9E9E9E;
		border-radius: 10px;
		padding: 10px;
	}
	.bg{
		background-image: url(static/bg.png);color: white;
		padding: 5px 0 20px 0;
	}
	.img-cen{
		display: flex;flex-direction: column;justify-content: center;align-items: center;
	}
	.images{
		width: 50px;height: 50px;
		padding-bottom: 5px;
	}
  .depositMessage{
    font-family: '微软雅黑',
    sans-serif;font-weight: 400;
    font-style: normal;
    color: #F59A23;
    text-align: left;
    line-height: 28px;
  }
  .titleContent{
    font-size: 15px;
    border-width: 1px;
    display: inline-block;
    font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
    font-weight: 700;
    font-style: normal;
    text-align: left;
  }
  .van-cell__value--alone {
    color: #F59A23;
    text-align: left;
  }
  .btn {
    margin-top: 1%;
    margin-bottom: 1%;
    border-radius: 5px;
    background-color: #2acba2 !important;
    border: 1px solid #2acba2 !important;
    float: right;
    height:35px;
  }
</style>
